//  压缩尺寸枚举
var W_H_ENUM = /*#__PURE__*/function (W_H_ENUM) {
  W_H_ENUM["242_136"] = "w_242,h_136";
  W_H_ENUM["120_66"] = "w_120,h_66";
  W_H_ENUM["48_48"] = "w_48,h_48";
  W_H_ENUM["218_123"] = "w_218,h_123";
  W_H_ENUM["121_68"] = "w_121,h_68";
  return W_H_ENUM;
}(W_H_ENUM || {});
/**
 * @name 获取压缩后图片的url
 * @desc 压缩尺寸默认'242_136',指定压缩宽高优先级大于压缩尺寸
 * @param compressObj 压缩对象
 * @param compressObj.url 图片地址
 * @param compressObj.width 压缩宽度
 * @param compressObj.height 压缩高度
 * @param compressObj.w_h_enum 压缩尺寸
 * @return string
 */
export var getCompressImg = function getCompressImg(compressObj) {
  var _ref = compressObj || {},
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? 'https://zpimg.cn/a/img/img.png' : _ref$url,
    width = _ref.width,
    height = _ref.height,
    _ref$w_h_enum = _ref.w_h_enum,
    w_h_enum = _ref$w_h_enum === void 0 ? '242_136' : _ref$w_h_enum;
  var compressUrl = width && height ? "h_".concat(height, ",w_").concat(width) : W_H_ENUM[w_h_enum];
  var imgUrl = "".concat(url, "?x-oss-process=image/resize,").concat(compressUrl);
  return imgUrl;
};